import { useQuery } from "@tanstack/react-query"
import { getReferralLeadsQuery } from "../lib/getReferralLeadsQuery"

export function useGetReferralLeadsQuery() {
  return useQuery(getReferralLeadsQuery())
}
